import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'
import getters from './getters.js'
import user from './modules/user.js'
import Jurisdiction from './modules/Jurisdiction.js'
import Loading from './modules/Loading.js'
import Token_Local from './modules/Token.js'

Vue.use(Vuex)

//分组管理持久化对象
const persistedState_session = new persistedState({
	key:'zoshu-sso-session',
	storage: window.sessionStorage,
	reducer(store) {
	    return {
			user:store.user
	    }
	}
})
const persistedState_local = new persistedState({
	key:'zoshu-sso-local',
	storage: window.localStorage,
	reducer(store){
	     return {
			Jurisdiction: store.Jurisdiction,
			Token_Local:store.Token_Local
	     }
	 }
})

const store = new Vuex.Store({
	modules: {
		user,
		Jurisdiction,
		Loading,
		Token_Local
	},
	getters,
	//持久化
	plugins: [persistedState_session,persistedState_local]
})

export default store



// WEBPACK FOOTER //
// ./src/store/store.js